<div class="wrap">
  <div class="padding-md top">
    <app-week-switcher
      (weekChanged)="onWeekChanged($event)"
      [shouldDisplayNextWeekButton]="(menuService.weeklyMenus$ | async)?.length! > 1"
      [selectedWeekId]="selectedWeekIndex"
    ></app-week-switcher>
    <div
      [appHidden]="(dailyMenu$ | async) !== null && (displayedDays$ | async)?.length === 0"
      [@valueChangedFadeInOut]="selectedDay.value"
      class="day-name"
    >
      {{selectedDay.value ? ('@pages.home.dayTitle.' + selectedDay.value |
      translate) : '...'}}
    </div>
    <div class="day-selector">
      <app-day-selector
        [selectedDay]="selectedDay.value"
        (daySelected)="onDaySelected($event, productList)"
        [displayedDays]="(displayedDays$ | async) || []"
        [weekIndex]="selectedWeekIndex"
      ></app-day-selector>
    </div>
  </div>
  <!-- <app-food-category-list></app-food-category-list> -->
  <div class="product-list" #productList>
    <app-product-list
      *ngIf="(displayedDays$ | async)?.length! > 0"
      [products]="(dailyMenu$ | async)?.meals"
      (productClicked)="openProductDetails($event)"
      [scrollTrigger]="scrollTrigger$"
    ></app-product-list>
    <div
      *ngIf="(selectedWeeklyMenu$ | async) !== null && (displayedDays$ | async)?.length! === 0"
      class="empty-list"
    >
      <div class="message">{{'@pages.home.noMealsThisWeek' | translate}}</div>
    </div>
    <div
      class="app-spinner-container"
      *ngIf="(selectedWeeklyMenu$ | async) === null"
    >
      <ion-spinner class="app-spinner"></ion-spinner>
    </div>
  </div>
</div>
